import { forwardRef, type ComponentProps } from 'react';
import cn from 'clsx';
import { cva } from 'class-variance-authority';
import { IconButton } from '@ev-tech/ui-core-components/IconButton';

import { type CarouselButtonProps, type CarouselContainerComponentProps } from './Carousel.types';

import styles from './Carousel.module.css';

const carouselButtonVariants = cva(styles.carouselButton, {
  variants: {
    direction: {
      left: styles.leftButton,
      right: styles.rightButton,
    },
  },
});

export const DefaultSliderWrapper = forwardRef<HTMLDivElement, CarouselContainerComponentProps>(({ children, className }, ref) => (
  <div className={cn(styles.sliderWrapper, className)} ref={ref}>
    {children}
  </div>
));

DefaultSliderWrapper.displayName = 'DefaultSliderWrapper';

export const DefaultSliderContainer = forwardRef<HTMLDivElement, CarouselContainerComponentProps>(({ children, className }, ref) => (
  <div className={cn(styles.sliderContainer, className)} ref={ref}>
    {children}
  </div>
));

DefaultSliderContainer.displayName = 'DefaultSliderContainer';

export const DefaultCarouselContainer = forwardRef<HTMLDivElement, CarouselContainerComponentProps>(({ children, className }, ref) => (
  <div className={cn(styles.carouselContainer, className)} ref={ref}>
    {children}
  </div>
));

DefaultCarouselContainer.displayName = 'DefaultCarouselContainer';

const DefaultCarouselButton = ({ className, direction, onClick, ...props }: CarouselButtonProps & { direction: 'left' | 'right' }) => (
  <IconButton
    {...({
      className: cn(carouselButtonVariants({ direction }), className),
      onClick,
      variant: 'transparent',
      ...props,
    } as ComponentProps<typeof IconButton>)}
  />
);

export const DefaultLeftCarouselButton = ({ className, ...props }: CarouselButtonProps) => (
  <DefaultCarouselButton className={className} direction="left" {...props} />
);

export const DefaultRightCarouselButton = ({ className, ...props }: CarouselButtonProps) => (
  <DefaultCarouselButton className={className} direction="right" {...props} />
);
